import { render, staticRenderFns } from "./Tabla.vue?vue&type=template&id=49fac158&"
import script from "./Tabla.vue?vue&type=script&lang=js&"
export * from "./Tabla.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports